.formGroup {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.row {
  flex-direction: row;
}
